import { render, staticRenderFns } from "./PwdStrategy.vue?vue&type=template&id=0ca1a25f&scoped=true&"
import script from "./PwdStrategy.vue?vue&type=script&lang=js&"
export * from "./PwdStrategy.vue?vue&type=script&lang=js&"
import style0 from "./PwdStrategy.vue?vue&type=style&index=0&id=0ca1a25f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca1a25f",
  null
  
)

export default component.exports